import { useState, useRef, useEffect, forwardRef, useMemo } from "react";
// import moment from "moment-timezone";
import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import CustomTextField from "components/Form/CustomTextField";

const MS_PER_MINUTE = 60000;

const options = [
  {
    label: "REG",
    value: "REG",
  },
  {
    label: "OT",
    value: "OT",
  },
  {
    label: "DT",
    value: "DT",
  },
  {
    label: "BONUS",
    value: "BONUS",
  },
  {
    label: "COMMISSION",
    value: "COMMISSION",
  },
  {
    label: "1099",
    value: "1099",
  },
];

const EditableCellDropdown = forwardRef(({ label, value, setValue, onKeyDown }, ref) => {
  const selectedOption = useMemo(() => {
    if (!value) return "";
    const foundItem = options.find((op) => op.value === value);
    return foundItem ?? "";
  }, [value]);

  const [displayOption, setDisplayOption] = useState(selectedOption);

  useEffect(() => {
    setDisplayOption(selectedOption);
  }, [selectedOption]);

  const handleBlur = (e) => {
    if (!displayOption) {
      setValue("");
      setDisplayOption("");
      return;
    }

    setValue(displayOption.value);
    setDisplayOption(displayOption);
  };

  return (
    <>
      <Autocomplete
        value={displayOption}
        options={options}
        autoSelect
        onChange={(e, v) => {
          setDisplayOption(v);
        }}
        onBlur={handleBlur}
        sx={{ maxHeight: "44px", width: "100%" }}
        disableClearable
        renderInput={(params) => (
          <CustomTextField
            variant="outlined"
            showError
            {...params}
            InputLabelProps={{ shrink: true }}
            inputRef={ref}
            onKeyDown={onKeyDown}
            sx={{
              "& input": {
                padding: "3px !important",
              },
            }}
          />
        )}
      />
    </>
  );
});

export default EditableCellDropdown;
